import React, { useContext } from 'react'
import { useAuth } from "react-oidc-context";
import { PhPartnerLayout } from 'usbc-web-react-partnerhub-library'
import { PhGenericLayout } from 'usbc-web-react-partnerhub-library'
import { config } from '../../../config'
import GlobalContext from '../../../store/global-context'
import { getUser } from '../../../hooks/useDashboardApi';

function Layout(props) {
    const auth = useAuth();
    const globalCtx = useContext(GlobalContext);

    function setLayoutModel(layoutModel) {
        globalCtx.setLayoutModel(layoutModel);
    }

    function setBannerModel(bannerModel) {
        globalCtx.setBannerModel(bannerModel);
    }

    let visibilityControl = {
        hideBreadCrumbs: props.hideBreadCrumbs,
        hideLeftNav: props.hideLeftNav,
        showRedirectBanner: config.showRedirectBanner
    };

    const user = getUser();
    const token = user?.access_token;

    return (
        props.isGeneric === true ?
            <PhGenericLayout appConfig={{ ...config, token: token }} auth={auth}>
                {props.children}
            </PhGenericLayout>
            :
            <PhPartnerLayout appConfig={{ ...config, token: token }} auth={auth}
                visibilityControl={visibilityControl}
                setLayoutModel={setLayoutModel}
                setBannerModel={setBannerModel}            >
                {props.children}
            </PhPartnerLayout>
    )
}

export default Layout